import { Routes, Route } from 'react-router-dom';
import React, { useEffect } from 'react';
import Main from './Main';

import 'bootstrap/dist/css/bootstrap.css';
import "bootstrap/dist/js/bootstrap.bundle.min.js";

import './App.css';   // 🔥 THIS WAS MISSING 🔥

import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { AuthProvider } from './context/AuthContext';
const theme = createTheme();

function App() {
  useEffect(() => {
    document.body.style.backgroundColor = '#e9f6f7';
  }, []);

  return (
    <div className="container-fluid">
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <AuthProvider>
            <Main />
        </AuthProvider>
      </ThemeProvider>
    </div>
  );
}

export default App;
